module.exports = __webpack_public_path__ + "static/media/tom.3917033c.png";